import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  getVisitProduct,
  getOrderItemsList,
  setConsultationTypeOrderItemAddon,
  removeConsultationTypeOrderItemAddon,
  getOriginalRefillOrderItems,
} from "~/visits/utils/visitCookies";

import { productName } from "~/visits/components/payment/paymentHelpers";

import { ProductImage } from "~/visits/components/payment/paymentComponents";

import { kickBlue } from "~/shared/styles/baseStyles";

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(1),
  },
}));

export default function ChooseRefillOrderItems({ match }) {
  const consultationType = match.params.consultationType;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const checkoutSessionID = queryParams.get("checkoutSessionID");
  if (!checkoutSessionID) {
    window.location.href = "/me/portal";
  }

  const classes = useStyles();
  const visitProduct = getVisitProduct(checkoutSessionID);
  const orderItems = getOrderItemsList(checkoutSessionID);

  const originalRefillOrderItems =
    getOriginalRefillOrderItems(checkoutSessionID);

  if (!originalRefillOrderItems) {
    window.location.href = `/me/portal`;
    return null;
  }

  if (originalRefillOrderItems.length < 2) {
    window.location.href = `/visits/${consultationType}/payment/order-details?checkoutSessionID=${checkoutSessionID}`;
    return null;
  }
  const [selectedOrderItems, setSelectedOrderItems] = useState(
    orderItems.map((oi) => oi.productSlug)
  );
  // Fall back to the first non-addon item if no slug matches the stamped
  // visitProduct (a visit whose orderType drifted from its order items) so a
  // mismatch degrades to a label difference instead of a render crash.
  const mainOrderItem =
    originalRefillOrderItems.find((oi) => oi.productSlug === visitProduct) ||
    originalRefillOrderItems.find((oi) => !oi.isAddon) ||
    originalRefillOrderItems[0];
  const addons = originalRefillOrderItems.filter((oi) => oi !== mainOrderItem);

  return (
    <main
      className={classes.content}
      style={{ backgroundColor: "#eee", minHeight: "100vh" }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "0 10px",
          maxWidth: "600px",
          margin: "0 auto",
        }}
      >
        <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
          Your Kick Refill
        </h3>

        <div
          style={{
            marginBottom: "20px",
            backgroundColor: "white",
            border: "1px solid #ddd",
            borderRadius: "6px",
            width: "100%",
            boxSizing: "border-box",
            padding: "20px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ width: "60px" }}>
              <ProductImage
                classes={classes}
                consultationType={mainOrderItem.consultationType}
                productType={mainOrderItem.productSlug}
                subcategory={mainOrderItem.subcategory}
                checkoutSessionID={checkoutSessionID}
                imgStyle={{
                  height: "100px",
                  width: "100px",
                  objectFit: "scale-down",
                  paddingRight: "5px",
                }}
              />
            </div>
            <div
              style={{
                marginLeft: "20px",
                fontSize: "18px",
                lineHeight: "1.5",
                padding: "0 18px",
              }}
            >
              {productName(
                mainOrderItem.productSlug,
                mainOrderItem.subcategory,
                checkoutSessionID
              )}
            </div>
          </div>
        </div>

        <h4
          style={{
            textAlign: "center",
            marginBottom: "20px",
            marginTop: "20px",
          }}
        >
          Also reorder these products?
        </h4>
        <div
          style={{
            padding: "20px",
            border: "1px solid #ddd",
            borderRadius: "6px",
            backgroundColor: "white",
            maxWidth: "600px",
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          {addons.map((orderItem) => (
            <div key={orderItem.productSlug}>
              <div style={{ display: "flex", alignItems: "center" }}>
                {orderItem.productSlug !== visitProduct && (
                  <Checkbox
                    style={{ color: kickBlue }}
                    checked={selectedOrderItems.includes(orderItem.productSlug)}
                    onChange={() => {
                      if (selectedOrderItems.includes(orderItem.productSlug)) {
                        setSelectedOrderItems(
                          selectedOrderItems.filter(
                            (slug) => slug !== orderItem.productSlug
                          )
                        );
                        removeConsultationTypeOrderItemAddon(
                          orderItem.consultationType,
                          orderItem.productSlug,
                          checkoutSessionID
                        );
                      } else {
                        setSelectedOrderItems([
                          ...selectedOrderItems,
                          orderItem.productSlug,
                        ]);
                        setConsultationTypeOrderItemAddon(
                          orderItem.consultationType,
                          orderItem.productSlug,
                          orderItem.subcategory,
                          checkoutSessionID
                        );
                      }
                    }}
                  />
                )}
                <div style={{ width: "60px" }}>
                  <ProductImage
                    classes={classes}
                    consultationType={orderItem.consultationType}
                    productType={orderItem.productSlug}
                    subcategory={orderItem.subcategory}
                    checkoutSessionID={checkoutSessionID}
                    imgStyle={{
                      height: "80px",
                      width: "80px",
                      objectFit: "scale-down",
                    }}
                  />
                </div>
                <div style={{ marginLeft: "20px", fontSize: "16px" }}>
                  {productName(
                    orderItem.productSlug,
                    orderItem.subcategory,
                    checkoutSessionID
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <Button
          color="primary"
          size="large"
          style={{
            backgroundColor: kickBlue,
            color: "white",
            margin: "60px 0",
            width: "300px",
          }}
          onClick={() => {
            window.location.href = `/visits/${consultationType}/payment/order-details?checkoutSessionID=${checkoutSessionID}`;
          }}
        >
          Continue <NavigateNextIcon />
        </Button>
      </div>
    </main>
  );
}
